export default "__VITE_ASSET__Dg4$Gszw__"